import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBoundary]", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            padding: 32,
            textAlign: "center",
            color: "#e0e0e0",
            minHeight: 200,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 16,
          }}
        >
          <h2 style={{ margin: 0, color: "#ef5350" }}>Something went wrong</h2>
          <p style={{ margin: 0, maxWidth: 480 }}>
            An unexpected error occurred. Try refreshing the page or navigating back.
          </p>
          <div style={{ display: "flex", gap: 8 }}>
            <button
              onClick={() => this.setState({ hasError: false, error: null })}
              style={{
                padding: "8px 16px",
                borderRadius: 6,
                border: "2px solid #1565c0",
                background: "#1565c0",
                color: "#fff",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Try Again
            </button>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: "8px 16px",
                borderRadius: 6,
                border: "2px solid #616161",
                background: "#212121",
                color: "#fff",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Reload Page
            </button>
          </div>
          {this.state.error && (
            <details style={{ fontSize: 12, opacity: 0.7, maxWidth: 600, textAlign: "left" }}>
              <summary>Error details</summary>
              <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", marginTop: 8 }}>
                {this.state.error.message || String(this.state.error)}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}
